import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import platformCard from '@blade-sxp/device-management/components/platformCard.vue';
import basePlatform from '@blade-sxp/device-management/components/basePlatform.vue';
import { getPlatformItemConfig, getPlatformDeviceConfig } from '@blade-sxp/device-management/config/platformDeviceConfig';
import { addPlatform, editPlatform, getDeviceList, delPlatform, getPlatformList, getBasePlatform, } from '@blade-sxp/device-management/api/device-group-management';
import { cloneDeep } from 'lodash';
const API = {
    addPlatform,
    editPlatform,
    getDeviceList,
    delPlatform,
    getPlatformList,
    getBasePlatform,
};
let Platforms = class Platforms extends Vue {
    dialogType; // 弹框类型
    stepIndex; // 执行步骤
    groupNameOption; // 分组名称数据
    reviewData; // 回显平台设备数据
    disabled;
    changeStepIndex(val) {
        this.stepIndex = val;
    }
    onDialogTypeChange(type) {
        this.init();
    }
    onGroupNameOption() {
        this.updateGroupNameOption();
    }
    onReviewData(nv) {
        this.initReviewData();
    }
    // 平台
    platforms = [];
    oldPlatforms = [];
    defaultPlatform = {
        id: '',
        name: '',
        localFlag: false,
        code: '',
        ip: '',
        port: '',
        userName: '',
        password: '',
        heartInterval: 0,
        maxBeats: 0,
    };
    addPlatformConfig = getPlatformItemConfig('add');
    platfromConfig;
    editPlatfromConfig;
    activeNames = '';
    isAddPlatfrom = false;
    relativePlatformDeviceNum = 0;
    platformRules = {
        name: [
            { required: true, message: this.$t('nameTips'), trigger: 'blur' },
            { min: 1, max: 20, message: this.$t('maxLengthTips', { max: 20 }), trigger: 'blur' },
        ],
        code: [
            { required: true, message: this.$t('codeTips'), trigger: 'blur' },
            { min: 1, max: 20, message: this.$t('maxLengthTips', { max: 20 }), trigger: 'blur' },
        ],
        ip: [
            {
                required: true,
                message: this.$t('device.IPAddress'),
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!/([0-9]\.?)+$/.test(value)) {
                        return callback(new Error(this.$t('device.IPAddress').toString()));
                    }
                    callback();
                },
            },
        ],
        port: [
            {
                required: true,
                message: this.$t('device.port'),
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!/[0-9]{1,6}$/.test(value) || Number(value) < 0 || Number(value) > 65535) {
                        return callback(new Error(this.$t('device.Port').toString()));
                    }
                    callback();
                },
            },
        ],
        userName: [{ required: false, message: this.$t('userNameTips'), trigger: 'blur' }],
        password: [{ required: false, message: this.$t('passwordTips'), trigger: 'blur' }],
    };
    //  平台设备
    platfromDeviceRef = 'platfromDeviceRef';
    platfromDeviceConfig = getPlatformDeviceConfig(this.dialogType);
    platformDeviceData = {
        accessPlatform: '',
        groupName: '',
        deviceList: [],
        notes: '',
        deviceCode: '',
        deviceName: '',
        platformDeviceId: '',
        platformId: '',
    };
    platformDeviceRules = {
        accessPlatform: [{ required: true, message: this.$t('accessPlatformPlaceholder'), trigger: 'change' }],
        groupName: [{ required: true, message: this.$t('groupNamePlaceholder'), trigger: 'change' }],
        deviceList: [{ type: 'array', required: true, message: this.$t('diveListPlaceholder'), trigger: 'change' }],
        notes: [
            { required: false, message: this.$t('reviewIdPlaceholder'), trigger: 'blur' },
            { min: 1, max: 200, message: this.$t('maxLengthTips', { max: 200 }), trigger: 'blur' },
        ],
    };
    configDeviceList = [];
    get popconfirm() {
        return this.relativePlatformDeviceNum > 0
            ? this.$t('deletRelativePlatformAlert')
            : this.$t('deletPlatformAlert', { num: this.relativePlatformDeviceNum });
    }
    created() {
        this.init();
    }
    init() {
        this.initPlatformsList();
        this.initPlatformConfig();
        this.initDefaultFormValue();
        this.initPlatformDeviceConfig();
    }
    // 获取平台列表数据
    async initPlatformsList() {
        let platforms = [];
        try {
            const { platFormInfoList = [] } = (await API.getPlatformList());
            platforms = this.dealToPlatforms(platFormInfoList);
            this.platforms = platforms;
            this.oldPlatforms = cloneDeep(platforms);
        }
        catch (er) {
            console.log(er);
        }
        if (this.dialogType === 'add') {
            this.updatePlatformSelect();
        }
        else {
            this.initReviewData();
        }
    }
    // 设置回显数据
    initReviewData() {
        if (this.dialogType === 'add')
            return;
        const reviewData = { ...this.reviewData };
        const platformId = reviewData.accessPlatform;
        if (!platformId)
            return;
        const formData = this.platforms.filter((item) => item.platformId === platformId)?.[0] ?? this.platforms[0];
        this.platformDeviceData = reviewData;
        this.platformDeviceData.accessPlatform = formData?.platformId ?? ''; // 若无平台默认显示第一个平台
        this.updatePlatformSelect();
        this.$emit('selectedPlatform', formData);
    }
    initPlatformConfig() {
        this.platfromConfig = getPlatformItemConfig(this.dialogType);
        const editType = this.dialogType === 'view' ? 'view' : 'edit';
        this.editPlatfromConfig = getPlatformItemConfig(editType);
        this.platfromDeviceConfig = getPlatformDeviceConfig(this.dialogType);
    }
    initPlatformDeviceConfig() {
        this.updateGroupNameOption();
        this.updatePlatformSelect();
    }
    initDefaultFormValue() {
        const platformConfig = this.platfromConfig;
        const defaultPlatform = {
            name: '',
            id: '',
            localFlag: false,
            code: '',
            ip: '',
            port: '',
            userName: '',
            password: '',
            heartInterval: 0,
            maxBeats: 0,
        };
        const assignMent = function (key, value) {
            defaultPlatform[key] = value;
        };
        Object.keys(platformConfig.option).forEach((key) => {
            const tkey = key;
            const dKey = key;
            const { defaultValue = '' } = platformConfig.option[tkey];
            if (defaultValue) {
                assignMent(dKey, defaultValue);
            }
            // defaultValue && (defaultPlatform[dKey] = defaultValue);
        });
        this.defaultPlatform = { ...defaultPlatform };
    }
    updateGroupNameOption() {
        const groupNameOption = this.platfromDeviceConfig.option.groupName;
        this.$set(groupNameOption, 'options', [...this.groupNameOption]);
    }
    updatePlatformSelect() {
        const option = this.platfromDeviceConfig.option;
        const selectOptions = [];
        this.platforms.forEach((platform) => {
            const selectOption = {
                label: platform.name,
                value: platform.platformId,
                disabled: false,
            };
            selectOptions.push(selectOption);
        });
        this.$set(option.accessPlatform, 'options', [...selectOptions]);
    }
    // 将数据格式转为IPlatformData
    // arr 为后台返回数据
    dealToPlatforms(arr) {
        const platforms = [];
        arr.forEach((item) => {
            const platfrom = {
                name: item.platformName,
                id: item.id,
                localFlag: item.localFlag === 1,
                code: item.serverId,
                ip: item.ip,
                port: item.port,
                userName: item.userName,
                password: item.password,
                heartInterval: item.heartbeatSendingInterval,
                maxBeats: item.maximumNumberBeats,
                platformId: item.platformId,
            };
            platforms.push(platfrom);
        });
        return platforms;
    }
    handleAddPlatformBtn() {
        this.activeNames = '';
        this.isAddPlatfrom = !this.isAddPlatfrom;
        this.initDefaultFormValue();
    }
    handlePlatform(platformInfo) {
        const { btnKey, valid, formData } = platformInfo;
        switch (btnKey) {
            case 'save': // 添加 平台
                valid && this.addPlatformData(formData);
                break;
            case 'remove': // 删除添加
                this.isAddPlatfrom = false;
                break;
            case 'cancel': // 取消添加
                this.isAddPlatfrom = false;
                break;
            default:
        }
    }
    dealFormatParam(formData) {
        return {
            heartbeatSendingInterval: formData?.heartInterval,
            id: Number(formData?.id ?? ''),
            ip: formData?.ip,
            localFlag: formData?.localFlag ?? false ? 1 : 0,
            maximumNumberBeats: formData?.maxBeats,
            password: formData?.password,
            platformName: formData?.name,
            port: Number(formData.port),
            serverId: formData?.code,
            userName: formData?.userName,
        };
    }
    // 添加平台数据
    async addPlatformData(formData) {
        const param = this.dealFormatParam(formData);
        try {
            const res = (await API.addPlatform(param));
            formData.id = res?.id;
            formData.platformId = res.platformId;
            this.platforms.push(formData);
            this.msgTips('success');
            this.isAddPlatfrom = false;
        }
        catch (er) {
            console.log(er);
        }
        this.updatePlatformSelect();
    }
    // 删除、编辑平台数据后更新数据列
    handlePlatformBtn(platformInfo) {
        const { btnKey, formData, valid } = platformInfo;
        switch (btnKey) {
            case 'save':
                valid && this.editPlatformData(formData);
                break;
            case 'remove':
                this.removePlatform(formData);
                break;
            case 'cancel': // 取消添加
                // this.isAddPlatfrom = false;
                this.activeNames = ''; // 关闭折叠板
                break;
            default:
        }
    }
    // 编辑平台数据
    editPlatformData(formData) {
        // TO DO 调用编辑保存接口
        const param = this.dealFormatParam(formData);
        API.editPlatform(param)
            .then((res) => {
            const targetIndex = this.platforms.findIndex((item) => item.id === formData.id);
            this.platforms.splice(targetIndex, 1, { ...formData });
            this.msgTips('success');
            this.activeNames = ''; // 关闭折叠板
            this.updatePlatformSelect();
        })
            .catch(() => {
            // 平台编辑失败还原数据；
            this.platforms.forEach((item1, index) => {
                const res = this.oldPlatforms.filter((item2) => {
                    return item2.id === item1.id;
                });
                res[0] && this.platforms.splice(index, 1, res[0]);
            });
        });
        // const targetIndex = this.platforms.findIndex((item: IPlatformData) => item.id === formData.id);
        // this.platforms.splice(targetIndex, 1, { ...formData });
        // this.activeNames = ''; // 关闭折叠板
        // this.updatePlatformSelect();
    }
    msgTips(type, msg) {
        const message = msg || `${this.$t('success')}`;
        const msgType = type || 'success';
        this.$message({
            message: message,
            type: msgType,
        });
    }
    removePlatform(formData) {
        this.isAddPlatfrom = false;
        this.deletePlatformById(formData.id, formData?.platformId);
    }
    deletePlatform(formData) {
        // if (this.relativePlatformDeviceNum > 0) return; // 关联设备数> 0 不可删除
        this.deletePlatformById(formData.id, formData?.platformId);
    }
    deletePlatformById(id, platformId) {
        API.delPlatform(Number(id))
            .then((res) => {
            this.platforms = this.platforms.filter((item) => item.id !== id);
            // 删除设备时，如有已勾选的audio得清空
            const accessPlatform = this.platformDeviceData.accessPlatform;
            this.platformDeviceData.accessPlatform = accessPlatform === platformId ? '' : accessPlatform;
            if (!this.platformDeviceData.accessPlatform)
                this.$emit('deleteCheckedPlatform');
            this.updatePlatformSelect();
            this.msgTips('success');
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    async changePlatform(id, isBase) {
        const platformId = id;
        let items = this.platforms.filter((it) => {
            return id === it.platformId;
        });
        this.platformDeviceData.deviceCode = items[0].code;
        const res = (await API.getDeviceList(Number(platformId)));
        this.platformDeviceData.deviceList = [];
        // res.forEach((it:{addFlag:boolean, deviceCode:string}) => {
        //   if (it.addFlag) {
        //     this.platformDeviceData.deviceList.push(it.deviceCode);
        //   }
        // });
        this.configDeviceList = res;
        if (isBase)
            return; // 设备配置步骤，不往下执行
        this.$emit('selectedPlatform');
    }
    onCascaderChange(cascaderInfo) {
        this.$emit('onCascaderChange', cascaderInfo);
    }
    deviceCheckAll(list) {
        this.platformDeviceData.deviceList = list;
    }
    getDeleteRelativePlatformNum(formData) {
        // API.queryPlatformInfo(Number(formData.id)).then((res: any) => {
        //   this.relativePlatformDeviceNum = res?.deviceViews?.length ?? 0; // TODO 关联平台设备数
        // });
    }
    // 修改下级平台
    openCollapse(id) {
        this.activeNames = id;
        this.isAddPlatfrom = false;
    }
};
__decorate([
    Prop({ type: String, default: 'add' })
], Platforms.prototype, "dialogType", void 0);
__decorate([
    Prop({ type: Number })
], Platforms.prototype, "stepIndex", void 0);
__decorate([
    Prop()
], Platforms.prototype, "groupNameOption", void 0);
__decorate([
    Prop()
], Platforms.prototype, "reviewData", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], Platforms.prototype, "disabled", void 0);
__decorate([
    Watch('stepIndex', { immediate: true })
], Platforms.prototype, "changeStepIndex", null);
__decorate([
    Watch('dialogType')
], Platforms.prototype, "onDialogTypeChange", null);
__decorate([
    Watch('groupNameOption')
], Platforms.prototype, "onGroupNameOption", null);
__decorate([
    Watch('reviewData')
], Platforms.prototype, "onReviewData", null);
Platforms = __decorate([
    Component({
        name: 'platformsComponent',
        components: { platformCard, basePlatform },
        i18n: {
            messages: {
                en: {
                    // 平台
                    nameTips: 'Please enter national standard platform name',
                    codeTips: 'Please enter platform national standard code',
                    ipTips: 'Please enter IP',
                    portTips: 'Please enter port',
                    userNameTips: 'Please enter username',
                    passwordTips: 'Please enter password',
                    heartIntervalTips: 'Please enter heartbeat sending interval',
                    maxBeatsTips: 'Please enter maximum number of beats',
                    maxLengthTips: 'Max length {max}',
                    addPlatform: 'Add Platform',
                    deletPlatformAlert: 'All {num} Devices will lose the platform,Are you sure delete this Area?',
                    deletRelativePlatformAlert: 'Please delete the devices on this platform first， and try it again.',
                    success: 'Success',
                    ok: 'OK',
                    deletPlatPop: 'Are you sure delete this Area?',
                },
                zh: {
                    // 平台
                    deletPlatPop: '您确定要删除此平台吗？',
                    nameTips: '请输入国标平台名称',
                    codeTips: '请输入平台国际编码',
                    ipTips: '请输入IP地址',
                    portTips: '请输入端口号',
                    userNameTips: '请输入用户名',
                    passwordTips: '请输入密码',
                    heartIntervalTips: '请输入心跳发送间隔',
                    maxBeatsTips: '请输入最大心跳超时次数',
                    maxLengthTips: '不能超过最大{max}个字符',
                    addPlatform: '添加平台',
                    deletPlatformAlert: '{num}台设备都将失去平台，您确定要删除此平台吗？',
                    deletRelativePlatformAlert: '请先删除此平台上的设备，然后重试。',
                    success: '操作成功',
                    ok: 'OK',
                },
            },
        },
    })
], Platforms);
export default Platforms;
